import { render, staticRenderFns } from "./AttributesInputView.vue?vue&type=template&id=d6955c5a&scoped=true"
import script from "./AttributesInputView.vue?vue&type=script&lang=js"
export * from "./AttributesInputView.vue?vue&type=script&lang=js"
import style0 from "./AttributesInputView.vue?vue&type=style&index=0&id=d6955c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6955c5a",
  null
  
)

export default component.exports